import cx from "classnames";
import React, { memo } from "react";

interface IProps {
  disabled?: boolean;
  onClick: () => void;
}

const DuplicateButtonComponent = ({ disabled, onClick }: IProps) => (
  <a
    className={cx({ "text-primary": !disabled, "text-muted": disabled })}
    href="#"
    onClick={e => {
      e.preventDefault();
      if (!disabled) {
        onClick();
      }
    }}
    title="Duplicate"
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6667 5.25H6.41667C5.77233 5.25 5.25 5.77233 5.25 6.41667V11.6667C5.25 12.311 5.77233 12.8333 6.41667 12.8333H11.6667C12.311 12.8333 12.8333 12.311 12.8333 11.6667V6.41667C12.8333 5.77233 12.311 5.25 11.6667 5.25Z" fill="white" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.77775 1.36133H2.52775C1.88342 1.36133 1.36108 1.88366 1.36108 2.52799V7.778C1.36108 8.42233 1.88342 8.94466 2.52775 8.94466H7.77775C8.42208 8.94466 8.94442 8.42233 8.94442 7.778V2.52799C8.94442 1.88366 8.42208 1.36133 7.77775 1.36133Z" fill="white" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </a>
);
DuplicateButtonComponent.displayName = "DuplicateButton";
export const DuplicateButton = memo(DuplicateButtonComponent);
